const state = () => ({
  userProfile: getLocal('auth_user')
    ? JSON.parse(getLocal('auth_user'))
    : {},
  token: getLocal('token')
    ? JSON.parse(getLocal('token'))
    : {},
  /*
   * Descope-issued session held ALONGSIDE `token`, used only to authorize MFA calls.
   * Populated only when the primary session is not itself Descope-issued (i.e. a legacy
   * Member Hub login) — see use-descope-session.js. `token` stays the credential the API
   * interceptor and the rest of the app authenticate with; this never replaces it.
   */
  descopeSession: getLocal('descope_session')
    ? JSON.parse(getLocal('descope_session'))
    : {},
  /*
   * Set when a login/SSO callback has committed a session but Descope requires an SMS
   * challenge before it can stand: holds the session suspendAuthSession() parked, the
   * login id the challenge is for, and where to send the user once it's verified. Read
   * (and cleared) exclusively by dashboard/authorization/mfa-challenge.vue. See
   * use-mfa-post-login-gate.js.
   */
  pendingMfaChallenge: getLocal('pending_mfa_challenge')
    ? JSON.parse(getLocal('pending_mfa_challenge'))
    : {},
  /*
   * Same idea as pendingMfaChallenge, for enrolment instead of verification: set when a
   * login/signup has committed a session but MFA is mandatory and this account has not yet
   * enrolled. Holds the session suspendAuthSession() parked, the login id/phone enrolment
   * is for, and where to send the user once it completes. Without this, the session stayed
   * live and fully usable the whole time enrolment was merely "offered" — abandoning it
   * (refresh, back button, closing the tab) left a fully authenticated, MFA-less session
   * sitting in memory, defeating the entire point of making MFA mandatory. Read (and
   * cleared) exclusively by dashboard/setup-mfa.vue. See use-mfa-post-login-gate.js.
   */
  pendingMfaEnrollment: getLocal('pending_mfa_enrollment')
    ? JSON.parse(getLocal('pending_mfa_enrollment'))
    : {},
  /*
   * Set when the "lost phone number" recovery flow has verified the account's email but not
   * yet a new phone number: holds the session suspendAuthSession() parked, the login id, and
   * where to send the user once the new number verifies. Mirrors pendingMfaChallenge — the
   * primary session must stay suspended through both recovery steps, restored only once the
   * new phone is confirmed, never on email verification alone.
   */
  pendingMfaRecovery: getLocal('pending_mfa_recovery')
    ? JSON.parse(getLocal('pending_mfa_recovery'))
    : {},
  signUpData: null,
  authModuleParams: {},
  defaultAuthState: `auth_state_${Date.now()}`,
  psSignUp: false
})

export default state
